import { useScreenWidth } from "../../lib/hooks/useScreenWidth";
import { Drawer2 } from "../Drawer2";
import { Modal, ModalProps } from "./Modal";
import { TDrawer2Props } from "../Drawer2/ui/Drawer2";

export type ResponsiveModalProps = Omit<ModalProps & TDrawer2Props, "position"> & {
  mobileBreakpoint?: number;
};
export function ResponsiveModal({ mobileBreakpoint = 768, ...props }: ResponsiveModalProps) {
  const isMobile = useScreenWidth() <= mobileBreakpoint;
  if (!isMobile) {
    return <Modal {...props} />;
  } else {
    return <Drawer2 position="bottom" {...props} />;
  }
}
